'use client';

/**
 * The running server's build id, fetched once per page load and shared.
 *
 * Two readers want it: the stale-tab watchdog (`build-watchdog.tsx`), which
 * compares it on refocus, and the device store (`live-device.tsx`), which scopes
 * everything it holds to it. Asking twice on every page load is one request per
 * load for nothing, so the fetch is memoized here - the value cannot change
 * within a page's life without a new server, which is what the watchdog is for.
 *
 * `null` means the server did not answer (offline, mid-restart); every caller
 * decides what that means for it, and a later call tries again.
 */

let pending: Promise<string | null> | null = null;

export function loadBuildId(): Promise<string | null> {
  pending ??= fetch('/api/build', { cache: 'no-store' })
    .then((res) => (res.ok ? (res.json() as Promise<{ buildId?: string }>) : null))
    .then((body) => (body && typeof body.buildId === 'string' ? body.buildId : null))
    .catch(() => null);
  return pending;
}

/** Re-ask the server (the watchdog's refocus check, which must see a NEW build). */
export function refreshBuildId(): Promise<string | null> {
  pending = null;
  return loadBuildId();
}
